<template>
  <div>
    <section class="hero has-text-centered has-text-white
      has-font-family-britannic background-sea">
      <div class="hero has-text-centered has-text-white
      has-font-family-britannic greeting">
        <h1><b class="is-size-3">Welcome to Skipper'sBook</b></h1>
        <b>join us and be part of our community</b>
        <b>to make your yachting life convenient</b>
      </div>
    </section>

    <section class="has-text-centered has-text-primary has-font-family-britannic margin-top">
      <div v-if="user">
        <b class="is-size-4">Hello, {{userGreeting}}</b>
        <div class="has-text-secondary warning-text" v-if="!user.profile.profile_saved">
          Your profile is not complete yet, go to <i>Personal Info</i>
          to fill some basic information about yourself. Your profile won't
          appear in searches and some parts of the website will be hidden
          unless you complete this step
        </div>
      </div>
      <template v-else>
        <b class="is-size-4">Sign up and create your profile!</b>
        <div class="columns margin-top">
          <div class="column signup-item-container" v-for="i in signUpOptions" :key="i.type" >
            <SignUpItem v-bind="i" />
          </div>
        </div>
      </template>
    </section>

    <section>
      <p class="is-size-4 has-text-centered has-text-secondary margin-top
        has-font-family-britannic">
        <b>Latest Advertisements</b>
      </p>
      <div class="jobs-container margin-top">
        <div class="job-control">
          <a @click="getPreviousPage()" >
            <img :src="`${$publicPath()}ARROW_01.png`" height="40" width="20"/>
          </a>
        </div>
        <div class="columns" style="width: 100%;">
          <div v-for="job in latestJobs" :key="job.id" name="job-list column"
            class="job-item has-border-secondary list-complete-item">
            <div class="image-wrapper" v-if="job.images[0]">
              <div class="image-container"
                :style="`background-image: url('${job.images[0].file.file}')`" />
            </div>
            <div class="job-details-container">
              <div>
                <p><b  class="is-size-5 has-text-primary">{{job.employment_type}}</b></p>
                <p>{{job.short_description}}</p>
              </div>
              <div class="link">
                <router-link class="button is-primary"
                  :to="{name: 'job-view', params: {id: job.id}}"
                  tag="a">
                  Details
                </router-link>
              </div>
            </div>
          </div>
        </div>

        <div class="job-control">
          <a @click="getNextPage()">
            <img :src="`${$publicPath()}ARROW_02.png`" height="40" width="20"/>
          </a>
        </div>
      </div>
      <p class="has-text-secondary has-text-centered margin-top">
        <i>[use the arrows to navigate]</i>
      </p>
    </section>

    <ContactFooter />

  </div>
</template>

<script>
import { mapState } from 'vuex';
import SignUpItem from '@/views/auth/SignUp/SignUpItem';
import ContactFooter from '@/components/ContactFooter';


export default {
  components: {
    ContactFooter,
    SignUpItem,
  },
  data() {
    return {
      latestJobs: [],
      page: 1,
      hasNext: false,
      activeType: null,
      signUpOptions: [
        {
          title: 'Crew members',
          imageSrc: `${this.$publicPath()}ICON_CREW.png`,
          type: 'crew',
          why: [
            'meet people and seas of the world',
            'create new partnerships with owners, companies, brokers',
            'acquaint yourself directly with a charterer',
            'find permanent employment on a private boat',
            'be notified by email when an ad is filled in',
            'maintain your evaluation',
            'update your availability calendar',
            'find technicians anywhere',
            'find a diver anywhere',
            'use it for free',
          ],
        },
        {
          title: 'Owners • Brokers • Charter companies',
          imageSrc: `${this.$publicPath()}ICON_OWNERS.png`,
          type: 'owner',
          why: [
            'find the right crew for permanent or temporary work',
            'find crew to transfer your boat',
            'find technicians wherever you or your clients are',
            'find divers anywhere your boat is located',
            'find technicians for the winter in shipyards',
            'upload ads for whatever you are looking for',
            'evaluate partners',
            'use it for free',
          ],
        },
        {
          title: 'On dock Services',
          imageSrc: `${this.$publicPath()}ICON_ON_DOCK.png`,
          type: 'on_dock',
          why: [
            'start collaborating with new owners and companies',
            'find boats in your area or that are passing by which need your help',
            'be notified by email of ads which meet your requirements',
            'undertake winter maintenance in your field of expertise',
            'maintain evaluation from partners',
            'use it for free',
          ],
        },
        {
          title: 'Charterers',
          imageSrc: `${this.$publicPath()}ICON_CHARTERERS.png`,
          type: 'charterer',
          why: [
            'get to know the crew you need before chartering a boat',
            'find a technician anywhere in case something comes up',
            'find a diver anywhere if needed',
            'upload ads for what you are looking for',
            'have those who meet your requirements be notified by email',
            'evaluate partners',
            'use it for free',
          ],
        },
        {
          title: 'Divers',
          imageSrc: `${this.$publicPath()}ICON_DIVERS.png`,
          type: 'diver',
          why: [
            'start collaborating with new owners and companies',
            'find boats in your area or that are passing by which need your help',
            'be notified by email of ads which meet your requirements',
            'maintain evaluation from partners',
            'use it for free',
          ],
        },
      ],
    };
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
    }),
    userGreeting() {
      return [this.user.profile.first_name, this.user.profile.last_name].filter(i => i).join(' ') || this.user.email;
    },
  },
  methods: {
    async getNextPage() {
      if (!this.hasNext) {
        return;
      }
      this.page += 1;
      this.getJobsPage();
    },
    async getPreviousPage() {
      if (this.page === 1) {
        return;
      }
      this.page -= 1;
      this.getJobsPage();
    },
    async getJobsPage() {
      const newData = (await this.$http.get(
        'jobs/', {
          params: {
            offset: (this.page - 1) * 4,
            limit: 4,
            order: '-created',
          },
        },
      )).data;
      this.latestJobs = newData.results;
      this.hasNext = !!newData.next;
    },
  },
  created() {
    this.getJobsPage();
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/vars.scss';

.job-item {
  flex-direction: column;
  display: flex;
  flex: 1;
  border-radius: 2px;
  margin-left: 0.5vw;
  margin-right: 0.5vw;
  min-height: 150px;
  @media screen and (max-width: 768px) {
    flex-direction: row;
  }
}
.job-control {
  min-width: 50px;
  align-self: center;
  display: flex;
  justify-content: center;
}

.image-wrapper {
  display: flex;
  min-height: 150px;
  padding: 0.2rem;
  justify-content: center;
  @media screen and (max-width: 768px) {
    flex: 2;
  }
}
.image-container {
  display: flex;
  flex: 1;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;

}

.jobs-container {
  display: flex;
}

.job-details-container {
  padding: 0.2rem;
  display: flex;
  justify-content: space-between;
  flex-grow: 1;
  flex: 5;
  flex-direction: column;
  margin-top: 0.5rem;
  .link {
    display: flex;
    justify-content: flex-end;
  }
}

.margin-top {
  margin-top: 1rem;
}
.signup-item-container {
  padding: 0.5rem;
}

.warning-text {
  max-width: 400px;
  align-self: center;
  margin-left: auto;
  margin-right: auto;
}

.background-sea {
  display: flex;
  justify-content: flex-end;
  padding: 2rem;
  min-height: 350px;
  margin-left: calc(50% - 50vw);
  margin-right: calc(50% - 50vw);
  background-image: url("/SKIPPERSBOOK_HEADER_PHOTO_3.jpg");
  background-position: center;
}

.greeting {
  margin-top: 2rem;
}
</style>
